import i18next from 'i18next';

import { FILE_ERRORS } from '~constants/errors';

export const FILE_ERRORS_MESSAGES = {
  [FILE_ERRORS.UNABLE_TO_UPLOAD_FILES]: i18next.t('FileUploaderModal:unableToUploadFilesError')
};
